'use client'
import { useState, useCallback, useMemo, useRef } from 'react'
import { FeaturedProfiles as FeaturedProfilesData } from '@/payload-types'
import { FeaturedProfiles } from '@/components/home-page/featuredProfiles'
import ProfileStories from '@/components/home-page/profileStories'
import { Stories as StoriesType } from '@/payload-types'
import { TypesenseData } from '@/lib/typesenseFunction'
import { transformProfilesData } from '@/lib/homePageFunctions'

export interface IBackgroundColor {
  backgroundColor: string,
  darkBackgroundColor: string
}
interface IProps {
  featuredProfilesData: FeaturedProfilesData
  backgroundColor?: IBackgroundColor
}
export const ProfilesSection = ({ featuredProfilesData, backgroundColor }: IProps) => {
  const profiles: TypesenseData[] = useMemo(
    () => transformProfilesData(featuredProfilesData),
    [featuredProfilesData],
  )
  const [profileStories, setProfileStories] = useState<StoriesType>(
    profiles?.[0]?.stories as StoriesType,
  )
  const featuredProfilesRef = useRef<{ stopAutoplay: () => void }>(null)

  const handleSelectedIndexChange = useCallback(
    (index: number) => {
      setProfileStories(profiles?.[index]?.stories as StoriesType)
    },
    [setProfileStories, profiles],
  )

  const handleImageClick = useCallback((): void => {
    featuredProfilesRef.current?.stopAutoplay()
  }, [])

  return (
    <>
      <ProfileStories profileStories={profileStories} onImageClick={handleImageClick} backgroundColor={backgroundColor} />
      <FeaturedProfiles
        ref={featuredProfilesRef}
        profiles={profiles}
        onSelectedIndexChange={handleSelectedIndexChange}
      />
    </>
  )
}

export default ProfilesSection
